module.exports = __webpack_public_path__ + "img/22.737d3c8c.png";